'use strict';

import storage from '@/core/storage'

const MENU_KEY = 'layout:slide-menu'

const enabled = storage.get(MENU_KEY)

var layoutMdl = angular.module('layoutMdl');

layoutMdl.component('layoutHeader', {

    template: require('./layout-head-template.html'),
    controller: headCtrl

});

headCtrl.$inject = [
    '$scope', 
    '$rootScope', 
    'Usuario', 
    'NotificacaoStream', 
    'notificacao', 
    'ConfigApp',
    'Event'];
function headCtrl($scope, $rootScope, Usuario, NotificacaoStream, notificacao, ConfigApp, Event ) {

    $scope.logout = function () {
        Usuario.logout();
    }

    $scope.menu = enabled == null ? true : enabled;
    $scope.menuEscondido = $scope.menu;

    $scope.alternarMenu = function () {
        $scope.$emit('layout.alternar-menu', $scope.menuEscondido = !$scope.menuEscondido);
    }

    $scope.$on('layout.alternar-menu', function (event, aberto) {
        $scope.menu = aberto;
    });

    function mensagens ( envelope ){
        if(Array.isArray(envelope.messages)){

            envelope.messages.forEach(function(message){
                notificacao.notificar({
                    titulo: message.Key,
                    mensagem: message.Value,
                    tipo: message.type,
                    driver: 'desktop'
                })
            })

        };
    }

    NotificacaoStream.ouvir('chamadoAberto', function( envelope ){
        Event.fire('meus-chamados:atualizar');
        mensagens(envelope)
    })

    NotificacaoStream.ouvir('atendimentoIniciado', function( envelope ){
        Event.fire('meus-chamados:atualizar')
             .fire('chamado:atualizar', envelope.payload)
        mensagens(envelope)
    })

    NotificacaoStream.ouvir('respostaEnviada', function( envelope ){
        Event.fire('meus-chamados:atualizar')
             .fire('chat:atualizar', envelope.payload)
        mensagens(envelope)
    })

}


// WEBPACK FOOTER //
// ./src/modules/layout/layout-head-component.js